import React, { useContext } from 'react'
import { ErpClientContext } from '../../services/erp'
import { Select } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { Button } from '@guillotinaweb/react-gmi'
import { groupOrders } from './delays'
import { linkOrder } from './common'
import { message } from 'antd'
import 'antd/dist/antd.css'
import { Affix } from 'antd'

import './order_preparation.css'

const getEmpresas = (data) => {
  return data
    .filter((item) => item.comprador !== 'uk' && item.comprador !== 'italvinus')
    .map((item, indx) => ({
      text: `${item.tienda} --> ${item.comprador}`,
      value: [item.tienda, item.comprador],
    }))
    .sort((a, b) => a.text.localeCompare(b.text))
}

export function GroupOrderPreparation() {
  const erpService = useContext(ErpClientContext)
  const [loading, setLoading] = React.useState(true)
  const [empresas, setEmpresas] = React.useState([])
  const [provider, setProvider] = React.useState(undefined)
  const [orders, setOrders] = React.useState(undefined)
  const [selected, setSelected] = React.useState([])
  const [doLoad, setDoLoad] = React.useState(false)

  React.useEffect(() => {
    ;(async () => {
      const resp = await erpService.get('/orders/@group-providers')
      if (resp.status === 200) {
        const d = await resp.json()
        console.log('empresas ', d)
        setEmpresas(d)
        setProvider(['vinissimus', 'fr'])
      }
    })()
  }, [])

  React.useEffect(() => {
    ;(async () => {
      setLoading(true)
      setSelected([])
      if (!provider) return
      const [emp, buyer] = provider
      const url = `/orders/@preparable-group-orders?shop=${emp}&buyer=${buyer}`
      const resp = await erpService.get(url)
      if (resp.status === 200) {
        const d = await resp.json()
        console.log('orders', d)
        setOrders(groupOrders(d))
      }
      setLoading(false)
    })()
  }, [provider, empresas, doLoad])

  const handleCheckbox = (state) => (ev) => {
    console.log('click checkbox')
    let result = []
    if (state.includes(ev.target.value)) {
      result = state.filter((item) => ev.target.value != item)
    } else {
      result = [...state, ev.target.value]
    }
    setSelected(result)
  }

  const mergeOrders = async (orders, provider, doLoad) => {
    //message.success(`Order ${row[0].cod_pedido} completed!`)
    const [shop, buyer] = provider
    const url = '/orders/@merge-group-orders'
    const data = {
      orders,
      shop,
      buyer,
    }
    setSelected([])
    setLoading(true)
    const resp = await erpService.request(url, 'post', data)
    if (resp.status === 200) {
      const d = await resp.json()
      message.success(`Merged to ${d.id_pedido}`)
    } else {
      const error = await resp.json()
      message.error(`An error ocurred ${JSON.stringify(error)}`)
    }
    setLoading(false)
    setDoLoad(!doLoad)
  }

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <Affix offsetTop={10}>
        <div className="level" style={{ margin: '10px' }}>
          <div className="level-left">
            <h2 className="title is-size-5">Group Orders</h2>
          </div>
          <div className="level-right is-size-7">
            {selected.length > 0 && (
              <Button
                className="button is-small is-primary"
                onClick={(ev) => mergeOrders(selected, provider, doLoad)}
                style={{ marginRight: '10px' }}
                loading={loading}
              >
                Merge Orders
              </Button>
            )}
            {empresas.length > 0 && (
              <Select
                onChange={(e) => {
                  setProvider(e.target.value.split(','))
                }}
                options={getEmpresas(empresas)}
                value={provider}
              />
            )}
          </div>
        </div>
      </Affix>

      {loading && <Loading />}
      {!loading && (
        <>
          <table
            className="ventas table is-bordered is-striped is-fullwidth is-size-7"
            style={{ marginTop: '30px' }}
          >
            <thead>
              <tr>
                <th></th>
                <th>Order</th>
                <th>Id Producto</th>
                <th>CON/SIN</th>
                <th>C.pedido</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(orders).map((ped) => (
                <>
                  <tr className={getStatus(orders[ped]) + ' sheader'} key={ped}>
                    <td>
                      <input
                        type="checkbox"
                        className="checkbox"
                        value={orders[ped][0].id_pedido}
                        onChange={handleCheckbox(selected)}
                      />
                    </td>
                    <td colspan="2">
                      <a
                        href={linkOrder(provider, orders[ped][0].id_pedido)}
                        target="_pedido"
                      >
                        {ped}
                      </a>
                    </td>
                    <td colspan="2">{getStatus(orders[ped])}</td>
                  </tr>
                  {orders[ped].map((order) => (
                    <tr key={`${order.id_pedido} /${order.id_producto}`}>
                      <td></td>
                      <td></td>
                      <td>{order.id_producto}</td>
                      <td>{order.case}</td>
                      <td>{order.cantidad_pedido}</td>
                      {/* <td><pre>{JSON.stringify(order, null, 2)}</pre></td> */}
                    </tr>
                  ))}
                </>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  )
}

const getStatus = (items) => {
  let result = 'SIN'
  items.map((item) => {
    if (item.case === 'CON') result = 'CON'
  })
  return result
}
